import { createGetAPI, createPostAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const {
  useGet: useGetProspectDetails,
  invalidate: invalidateProspectDetails,
} = createGetAPI({
  getURL: prospectId => `${BASE_URL}/lead/${prospectId}/details/`,
});

const { usePost: usePostLeadDetails } = createPostAPI({
  getURL: (_, parentId) => `${BASE_URL}/parents/${parentId}/student/v2`,
});

const { usePost: usePostConfirmationLink } = createPostAPI({
  getURL: (_, studentId) => `${BASE_URL}/students/${studentId}/trial-confirmation-link`,
});

const { usePost: usePostAssessment } = createPostAPI({
  getURL: (_, studentId) => `${BASE_URL}/students/${studentId}/assessment`,
});

const { usePost: usePostTrialCancel } = createPostAPI({
  getURL: (_, studentId) => `${BASE_URL}/students/${studentId}/trial-cancel`,
});

const { usePost: usePostTrialSlot } = createPostAPI({
  getURL: (_, studentId) => `${BASE_URL}/students/${studentId}/trial-slot`,
});

export {
  useGetProspectDetails,
  usePostLeadDetails,
  invalidateProspectDetails,
  usePostConfirmationLink,
  usePostAssessment,
  usePostTrialCancel,
  usePostTrialSlot,
};
